import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, SparklesIcon } from 'lucide-react';
export function PromoPopup() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const alreadyShown = sessionStorage.getItem('inkova_promo_shown');
    if (!alreadyShown) {
      const timer = setTimeout(() => {
        setIsOpen(true);
        sessionStorage.setItem('inkova_promo_shown', 'true');
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleClose = () => setIsOpen(false);
  return <AnimatePresence data-id="element-363">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50" onClick={handleClose} data-id="element-364" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        duration: 0.35,
        ease: [0.16, 1, 0.3, 1]
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-365">
            <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full pointer-events-auto overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-366">
              {/* Accent top bar */}
              <div className="h-1.5 bg-gradient-to-r from-inkova-primary to-inkova-accent" data-id="element-367" />

              {/* Close button */}
              <button onClick={handleClose} className="absolute top-4 right-4 p-1.5 rounded-full text-gray-400 hover:text-inkova-primary hover:bg-inkova-light transition-colors" aria-label="Close popup" data-id="element-368">
                <XIcon className="w-5 h-5" data-id="element-369" />
              </button>

              <div className="px-8 pt-8 pb-6" data-id="element-370">
                {/* Icon */}
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-inkova-light mb-5" data-id="element-371">
                  <SparklesIcon className="w-6 h-6 text-inkova-primary" data-id="element-372" />
                </div>

                {/* Headline */}
                <h2 className="text-2xl font-serif font-semibold text-inkova-dark mb-2" data-id="element-373">
                  Special Discount Available
                </h2>
                <p className="text-gray-600 text-sm leading-relaxed mb-6" data-id="element-374">
                  Get an exclusive discount on our services:
                </p>

                {/* Discount codes */}
                <div className="space-y-3 mb-8" data-id="element-375">
                  <div className="flex items-center justify-between bg-inkova-light rounded-xl px-5 py-4" data-id="element-376">
                    <div data-id="element-377">
                      <p className="text-sm font-medium text-inkova-dark" data-id="element-378">
                        Plan 2
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-379">
                        Strategic Landing Page
                      </p>
                    </div>
                    <span className="font-mono text-sm font-bold tracking-wider text-inkova-primary bg-white px-3 py-1.5 rounded-lg border border-inkova-accent/30" data-id="element-380">
                      LAUNCH30
                    </span>
                  </div>
                  <div className="flex items-center justify-between bg-inkova-light rounded-xl px-5 py-4" data-id="element-381">
                    <div data-id="element-382">
                      <p className="text-sm font-medium text-inkova-dark" data-id="element-383">
                        Plan 3
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-384">
                        Inkova Full Creation
                      </p>
                    </div>
                    <span className="font-mono text-sm font-bold tracking-wider text-inkova-primary bg-white px-3 py-1.5 rounded-lg border border-inkova-accent/30" data-id="element-385">
                      INKOVA30
                    </span>
                  </div>
                </div>

                {/* CTA */}
                <a href="#planes" onClick={handleClose} className="block w-full text-center bg-inkova-primary hover:bg-inkova-dark text-white font-medium py-3.5 rounded-xl transition-colors duration-200 text-sm" data-id="element-386">
                  View Services
                </a>

                {/* Secondary close */}
                <button onClick={handleClose} className="block w-full text-center text-gray-400 hover:text-gray-600 text-xs mt-3 py-1 transition-colors" data-id="element-387">
                  Continue browsing
                </button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}